module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    attrs: {
      "id": "lesson-bonus"
    }
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 48
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('mu-content-block', {
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', {
    domProps: {
      "textContent": _vm._s(_vm.data.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subTitle"
  }, [_vm._v("\n        " + _vm._s(_vm.data.summary) + "\n      ")])]), _vm._v(" "), _c('iframe-video-player', {
    attrs: {
      "src": _vm.data.video_player_url
    }
  }), _vm._v(" "), _c('questions-panel', {
    attrs: {
      "courseId": _vm.data.course_id
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-972853b2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LessonBonus/LessonBonus.vue
// module id = 3817
// module chunks = 1